import moment from 'moment';
import i18n from 'l10n';
import Chart from 'chartjs';
import ch from 'libs/chart-helpers';
import Handlebars from 'handlebars';

const it = {};

const queryOptions = {
    from: null, //long millis
    to: null, //long millis
    unit: 'day',
    dow: null //first day of week (0-Sunday ...)
};

it.options = {
    from: null, //moment
    to: null, //moment
    window: null,
    queryOptions: queryOptions
};

it.options.from = moment().startOf('day').subtract(6, 'days');
it.options.to = moment().endOf('day');
const startOf = it.options.from.clone();
it.options.queryOptions.from = startOf.toDate().getTime();
const endOf = it.options.to.clone();
it.options.queryOptions.to = endOf.toDate().getTime();
const last7days = i18n.labels7ConsecutiveDays(moment());
moment().localeData();

it.init = function (piesSelector, chartSelector) {

    const getChartItem = (label, color, data) => {
        return {
            label: label,
            fillColor: ch.colors[color].transparent,
            strokeColor: ch.colors[color].solid,
            pointColor: ch.colors[color].solid,
            pointStrokeColor: '#fff',
            pointHighlightFill: '#fff',
            pointHighlightStroke: ch.colors[color].solid,
            data: data
        };
    };

    const updateElements = (a, b) => {
        a.text(b);
        const cl = Handlebars.helpers.dynamicFontSize(b, a.data("font-length"));
        a.addClass(cl.toString());
    };

    const getServiceDataItem = (value, color) => {
        return {
            value: value,
            color: color
        };
    };

    const hanlder2 = $.ajaxDefaultQ({
        url: '/CampaignCloud/Report/PointsChart',
        type: 'POST',
        data: JSON.stringify(it.options.queryOptions),
        contentType: 'application/json',
        dataType: 'json'
    }).done(function (json) {

            const data2 = {
                 labels: last7days,
                 datasets: [getChartItem(i18n.t('spamAssassinPoints'), 'mauveUno', json.pointsRedeemed)]
             };
            const options2 = {
                legendTemplate2: "<% for (var i = 0; i < datasets.length; i++) { %>" +
                                    "<span class=\"chartContentInfo\">" +
                                        "<span style=\"background-color: <%=datasets[i].strokeColor%>; " +
                                                      "width:15px; height:10px; display: inline-block\">" +
                                        "</span>" +
                                        "<% if (datasets[i].label) { %>" +
                                            "<%=datasets[i].label%>" +
                                        "<% } %>" +
                                    "</span>" +
                                "<% } %>" +
                                "<br/>" +
                                "<div style=\"align: center\">" +
                                    "<a id=\"exportPointsLink\" class=\"export-button\">" +
                                        "<span id=\"exportPointsLinkTitle\">" +
                                        "</span>" +
                                    "</a>" +
                                "</div>",
                bezierCurve: false,
                responsive: true,
                datasetFill: false
            };

            const ctx2 = $("#points-line-chart").get(0).getContext("2d");
            const myLineChart2 = new Chart(ctx2).Line(data2, options2);
            const legend2 = myLineChart2.generateLegend();

            $(".pointsLastWeekText").text(i18n.t("dashboard.pointsContacts"));
            $("#points-text-last-week").text(i18n.t("dashboard.pointsContactsRedemptions"));
            $('#clicksPointsTable').html(legend2).find('#exportPointsLink').click(function () {
                const encodedUri = ch.exportHandler(myLineChart2);
                $('#exportPointsLink').attr({
                    'href': encodedUri,
                    'download': 'LastSevenDaysServicesChart.txt',
                    'id': 'exportPointsLink'
                });
                $('#exportPointsLinkTitle').text(i18n.t("dashboard.export"));
            }).click();

            let totalPointsRedeemlastWeek = 0;
            let totalPointsRedemptionslastWeek = 0;
            const totalPoints = json.totalPoints;
            const $chartSelector = $('#points-tile-last-week');
            totalPointsRedeemlastWeek = totalPointsRedeemlastWeek + countAll(json.pointsRedeemed);
            totalPointsRedemptionslastWeek = totalPointsRedemptionslastWeek + countAll(json.pointRedemptions);
            $chartSelector.find('.pointsLastWeek').text(totalPointsRedeemlastWeek);
            $chartSelector.find('#pointsRedempetionsLastWeek').text(totalPointsRedemptionslastWeek);

            let pointsPercentage = 0;
            if (totalPoints !== 0) {
                pointsPercentage = getAppropriatePercentageValue((totalPointsRedeemlastWeek / totalPoints * 100), 0);
            }

            $(".points").text(totalPointsRedeemlastWeek);

            $chartSelector.find('#points-percentage').text(pointsPercentage + '%');
            const pb = $chartSelector.find("#increace-points-bar").progressbar();
            if (pointsPercentage > 100) {
                pb.progressbar('value', 100);
            } else {
                pb.progressbar('value', pointsPercentage);
            }


    }).fail(function (response) {
        console.log(response);
     });

    const handler1 = () => {
        return $.ajaxDefaultQ({
            url: '/CampaignCloud/Report/Last7days',
            type: 'get',
            dataType: 'json'
        }).done((json) => {

            const data = {
                labels: last7days,
                datasets: [getChartItem(i18n.t('reports.downloadschartlabel'), 'mauveUno', json.dlLastWeekDistinct),
                    getChartItem(i18n.t('reports.optoutInitlabel'), 'blueDue', json.optoutLastWeekDistinct),
                    getChartItem(i18n.t('reports.voucherschartlabel'), 'greenTre', json.voucherLastWeekDistinct),
                    getChartItem(i18n.t('reports.survey_label'), 'orangeCinque', json.surveyLastWeekDistinct),
                    getChartItem(i18n.t('reports.linkchartlabel'), 'peachQuattro', json.urlLastWeekDistinct),
                    getChartItem(i18n.t('reports.optinVisitslabel'), 'brownSei', json.optinsVisitsLastWeek)]
            };

            const options = {
                legendTemplate: "<% for (var i = 0; i < datasets.length; i++) { %>" +
                                    "<span class=\"chartContentInfo\">" +
                                        "<span style=\"background-color: <%=datasets[i].strokeColor%>; " +
                                                      "width:15px; height:10px; display: inline-block\">" +
                                        "</span>" +
                                        "<% if (datasets[i].label) { %>" +
                                            "<%=datasets[i].label%>" +
                                        "<% } %>" +
                                    "</span>" +
                                "<% } %>" +
                                "<br/>" +
                                "<div style=\"align: center\">" +
                                    "<a id=\"exportPiesLink\" class=\"export-button\">" +
                                        "<span id=\"exportPiesLinkTitle\">" +
                                        "</span>" +
                                    "</a>" +
                                "</div>",
                bezierCurve: false,
                responsive: true,
                datasetFill: false
            };

            const ctx = $("#piesChart").get(0).getContext("2d");
            const myLineChart = new Chart(ctx).Line(data, options);
            const legend = myLineChart.generateLegend();

            $('#piesInfoTable').html(legend).find('#exportPiesLink').click(function () {
                const encodedUri = ch.exportHandler(myLineChart);
                $('#exportPiesLink').attr({
                    'href': encodedUri,
                    'download': 'LastSevenDaysServicesChart.txt',
                    'id': 'exportPiesLink'
                });
                $('#exportPiesLinkTitle').text(i18n.t("dashboard.export"));
            }).click();

        }).fail((response) => {
            console.log(response);
        });

    };

    false && $.when(handler1()).done((json) => {

        let totalServicesViewed = 0;
        let totalServicesSent = 0;

        totalServicesSent = totalServicesSent + countAll(json.optoutLastWeekSent);
        totalServicesSent = totalServicesSent + countAll(json.urlLastWeekSent);
        totalServicesSent = totalServicesSent + countAll(json.voucherLastWeekSent);
        totalServicesSent = totalServicesSent + countAll(json.dlLastWeekSent);
        totalServicesSent = totalServicesSent + countAll(json.totalSurveysLastWeekSent);
        totalServicesViewed = totalServicesViewed + countAll(json.optoutLastWeekDistinct);
        totalServicesViewed = totalServicesViewed + countAll(json.urlLastWeekDistinct);
        totalServicesViewed = totalServicesViewed + countAll(json.voucherLastWeekDistinct);
        totalServicesViewed = totalServicesViewed + countAll(json.dlLastWeekDistinct);
        totalServicesViewed = totalServicesViewed + countAll(json.surveyLastWeekDistinct);

        $(chartSelector).find('#total-services-sent').text(totalServicesSent);
        $(chartSelector).find('#total-services-viewed').text(totalServicesViewed);

        let percentage = 0;
        if (totalServicesSent !== 0) {
            percentage = getAppropriatePercentageValue((totalServicesViewed / totalServicesSent * 100), 0);
        }

        $(chartSelector).find('#services-percentage').text(percentage + '%');
        const pb = $(chartSelector).find("#increace-services-bar").progressbar();
        if (percentage > 100) {
            pb.progressbar('value', 100);
        } else {
            pb.progressbar('value', percentage);
        }

        drawLinkPie(countAll(json.urlLastWeekDistinct),
            countAll(json.urlLastWeek),
            countAll(json.urlLastWeekSent));
        drawVoucherPie(countAll(json.voucherLastWeekSent),
            countAll(json.voucherLastWeekDistinct),
            countAll(json.voucherLastWeekTotalRedemptions));
        drawDLPie(countAll(json.dlLastWeekDistinct),
            countAll(json.dlLastWeek),
            countAll(json.dlLastWeekSent));
        drawSurveyPie(countAll(json.surveyAnswersLastWeek),
            countAll(json.surveysLastWeekSent));
        drawOptinPie(countAll(json.optinsVisitsLastWeek),
            countAll(json.optinsAcquisitionsLastWeek)); // Optin
        // json.actualOptoutsLastWeek shouldn't be compared to json.optoutLastWeekSent. They are apples and oranges.
        // actualOptoutsLastWeek has been replaced with optoutLastWeekDistinct
        drawOptoutPie(countAll(json.actualOptoutsLastWeek),
            countAll(json.optoutLastWeekSent),
            countAll(json.contactsBeginningOfWeek),
            countAll(json.numberOfLastWeekNewContacts));

    });

    const countAll = (service) => {
        let counter = 0;
        for (let i = 0; i < service.length; i++) {
            counter = counter + service[i];
        }
        return counter;
    };

    const getAppropriatePercentageValue = (val, charNumb) => {
        if(val < 1 && val > 0) {
            return val.toFixed(4);
        }
        return val.toFixed(charNumb);
    };

    const drawPie = (distinctUsedItems, usedItems, itemsSent,
                     totalUsedItemsElement, usedItemsTitleElement, usedItemsTitleDictionaryEntry,
                     itemsSentTitleElement, itemsSentTitleDictionaryEntry, usedItemsPercentageElement,
                     itemsSentElement, usedItemsPercentageColor, notUsedItemsPercentageColor,
                     pieElement) => {

        let usedItemsPercentage = 0;
        let notUsedItemsPercentage = 100;

        if (itemsSent > 0) {
            usedItemsPercentage = getAppropriatePercentageValue((distinctUsedItems / itemsSent * 100), 0);
            notUsedItemsPercentage = getAppropriatePercentageValue((100 - usedItemsPercentage), 0);
        }

        const $totalUsedItems = $(totalUsedItemsElement);
        updateElements($totalUsedItems, distinctUsedItems !== undefined ? distinctUsedItems : usedItems);

        $(usedItemsTitleElement).text(i18n.t(usedItemsTitleDictionaryEntry, {count: usedItems !== undefined ?
                usedItems : distinctUsedItems}));

        $(itemsSentTitleElement).text(i18n.t(itemsSentTitleDictionaryEntry, {count: itemsSent}));

        $(usedItemsPercentageElement).text(parseFloat(usedItemsPercentage).toFixed(2) + '%');

        if (usedItemsPercentage > 100) {
            notUsedItemsPercentage = 0;
        }

        $(itemsSentElement).text(itemsSent);

        const pieData = [
            getServiceDataItem(usedItemsPercentage, usedItemsPercentageColor),
            getServiceDataItem(notUsedItemsPercentage, notUsedItemsPercentageColor)
        ];

        const options = {
            responsive: false,
            percentageInnerCutout: 75,
            showTooltips: false
        };

        const pie = $(pieElement).get(0);
        const ctxPie = pie.getContext("2d");
        ctxPie.clearRect(0, 0, pie.width, pie.height);
        new Chart(ctxPie).Doughnut(pieData, options);

    };

    const drawLinkPie = (clickedLinksDistinct, totalLinksClicked, linkSent) => {

        drawPie(clickedLinksDistinct, totalLinksClicked, linkSent,
            '#totalLinksFollowed', '#totalLinksFollowedTitle', 'dashboard.clicks',
            '#totalLinksSentText', 'reports.urlssent', '#urlsClickedPercentage',
            '#totalLinksSent', 'rgba(8,212,252,1)', 'rgba(0,250,242,1)', '#linksPie');

    };

    const drawVoucherPie = (voucherSent, voucherRedemptionsDist, voucherRedemptionsTotal) => {

        drawPie(voucherRedemptionsTotal, voucherRedemptionsDist, voucherSent,
            '#totalVoucherRedemptions', '#totalVoucherRedemptionsTitle', 'dashboard.redemption',
            '#totalVouchersSentText', 'analytics.vouchersSent', '#vouchersRedeemedPercentage',
            '#totalVouchersSent', 'rgba(0,217,148,1)', 'rgba(72,250,161,1)', '#vouchersPie');

    };

    const drawDLPie = (clickedDlsDistinct, clickedDlsTotal, dlsSent) => {

        drawPie(clickedDlsDistinct, clickedDlsTotal, dlsSent,
            '#totalFileDownloads', '#totalFileDownloadsTitle', 'dashboard.dl',
            '#totalFilesSentText', 'reports.filessent', '#filesDownloadedPercentage',
            '#totalFilesSent', 'rgba(252,73,124,1)', 'rgba(255,130,172,1)', '#filesPie');

    };

    const drawSurveyPie = (surveyAnswer, surveysSent) => {

        drawPie(surveyAnswer, undefined, surveysSent,
            '#totalSurveysCompleted', '#totalSurveysCompletedTitle', 'dashboard.surveyCompleted',
            '#totalSurveysSentText', 'reports.Surveyssent', '#surveysCompletedPercentage',
            '#totalSurveysSent', 'rgba(255,128,0,1)', 'rgba(250,172,88,1)', '#surveysPie');

    };

    const drawOptinPie = (optinsVisited, optinsAcquisited) => {

        drawPie(optinsAcquisited, undefined, optinsVisited,
            '#totalOptinsAcquisitioned', '#totalOptinsAcquisitionedTitle', 'dashboard.newContact',
            '#totalOptinsVisitedText', 'optin.view', '#optinsAcquisitionedPercentage',
            '#totalOptinsVisited', 'rgba(127, 6, 0, 1)', 'rgba(255, 84, 76, 1)', '#optinsPie');

    };

    const drawOptoutPie = (optoutsFromLastWeeksLinks, totalSentOptouts) => {

        drawPie(optoutsFromLastWeeksLinks, undefined, totalSentOptouts,
            '#totalOptoutsClicked', '#totalOptoutsClickedTitle', 'dashboard.optout',
            '#totalOptoutsSentTitle', 'message.optouts', '#optoutsClickedPercentage',
            '#totalOptoutsSent', 'rgba(207,2,155,1)', 'rgba(199,56,170,1)', '#optoutsPie');

    };

};

export default it;

